exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HazardBreakdown .pieContainer{display:flex;justify-content:space-between;padding:1rem}.HazardBreakdown .pieContainer .pieChart{width:25vw}.HazardBreakdown .chartContainer{padding:1rem}\n", ""]);

// exports
